package no.vareflow.app.domain

enum class CloudSaveState {
    LOCAL_SAVED,
    WAITING_FOR_NETWORK,
    UPLOADING,
    CLOUD_CONFIRMED,
    ERROR
}

enum class AdaptiveLayout(private val nb: String, private val en: String) {
    PHONE("Telefon", "Phone"),
    TABLET("Nettbrett", "Tablet"),
    WINDOWS("Windows", "Windows");

    val label: String get() = t(nb, en)
}

data class SpotCheckRecord(
    val id: String,
    val sessionId: String?,
    val productId: String,
    val productName: String,
    val expectedQty: Double,
    val checkedQty: Double,
    val checkerUserId: String,
    val checkerName: String,
    val createdAt: Long,
    val matches: Boolean
)

data class RecognizedTextLine(
    val text: String,
    val confidence: Float
)

data class PrintableProduct(
    val id: String,
    val varenummer: String,
    val name: String,
    val unit: String,
    /** Section heading on the sheet (e.g. Rødvin); blank = none. */
    val undergruppe: String = ""
)
